module.exports = __webpack_public_path__ + "media/images/bg/group-course-wave-pink-4b278c596613b51cda637e2de9c58216.svg";